<template>
  <ul class="embedded-user-account-list">
    <li class="account-menu-header">
      <ChevronBack class="chevron-back" @click="toggleBurgerMenu" />
      <CloseBtn @click="toggleUserAccountMenu" class="nav-close-icon" />
    </li>
    <li class="user-account">
      <a :href="userDataUrl" target="_blank">My Account</a>
    </li>
    <li class="user-account">
      <a href="https://accounts.bistudio.com/profile">Bohemia Account</a>
    </li>
    <li class="log-out">
      <a :href="logoutUrl" id="log-out-text">Log Out</a>
    </li>
  </ul>
</template>
<script>
import ChevronBack from "../../assets/svg/chevron-back.svg?inline";
import CloseBtn from "../../assets/svg/close.svg?inline";
export default {
  name: "user-accounts",
  components: {
    ChevronBack,
    CloseBtn
  },
  data() {
    return {
      userAccountMenu: true,
      showBurger: false
    };
  },
  props: {
    loginUrl: {
      type: String
    },
    logoutUrl: {
      type: String
    },
    userDataUrl: {
      type: String
    },
    showUserAccountMenu: {
      type: Boolean,
      default: false
    },

    showHamburgerMenu: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toggleBurgerMenu() {
      this.showBurger = !this.showBurger;
      this.$emit("showHamburgerMenu", this.showBurger);
    },
    toggleUserAccountMenu() {
      this.$emit("showUserAccountMenu");
    }
  }
};
</script>

<style scoped lang="scss">
.embedded-user-account-list {
  font-size: 22px;
  width: 100%;
  list-style-type: none;
  padding: 0px;

  .account-menu-header {
    display: flex;
    justify-content: space-between;
    padding: 0 2em 2em 2em;

    .nav-close-icon {
      cursor: pointer;

      &:hover {
        filter: drop-shadow(0 0 0.75rem #fff);
      }
    }

    .chevron-back {
      cursor: pointer;

      &:hover {
        filter: drop-shadow(0 0 0.75rem #fff);
      }
    }
  }

  .user-account {
    padding-bottom: 1.25em;
    padding-left: 2em;
    cursor: pointer;

    &:hover,
    &.router-link-active {
      text-shadow: 0 0 1px #fff;
    }
  }

  li {
    font-family: "Istok Web", sans-serif;
  }

  .log-out {
    display: flex;
    background-color: #1c3857;
    height: 2.375em;
    margin-top: 2em;
    cursor: pointer;
    font-size: 18px;

    &:hover,
    &.router-link-active {
      text-shadow: 0 0 1px #f8451d;
    }

    #log-out-text {
      color: #f8451d;
      margin: auto;
    }
  }

  @media (min-width: 551px) and (max-width: 980px) {
    li {
      a {
        font-size: 1.2em;
      }
    }
  }
}
</style>
